import React from 'react';
import { Icon } from '@vectord/components';

import FilterSection from '../FilterSection';

export default function UpcomingClassesFilters() {
  return (
    <div className="m-v-s">
      <Icon
        name="filter-alt"
        className="p-t-xxs m-r-xxs h5"
      />
      <label className="dark bold">Filters</label>
      <FilterSection />
    </div>
  );
}
